/**
 * @param {String} phoneNumber
 *
 * @return {String}
 */
export function phoneNumberFormat(phoneNumber) {
  return phoneNumber.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
}

/**
 * Chunk list
 *
 * @param {Array}  source
 * @param {Number} columns
 *
 * @return {Array}
 */
export function chunk(source, columns = 2) {
  const chunkedData = [];
  const data = source.slice(0);
  const itemsByColumn = Math.ceil(data.length / columns);

  while (data.length > 0) {
    chunkedData.push(data.splice(0, itemsByColumn));
  }

  return chunkedData;
}

/**
 * @param {Number} time
 *
 * @return {Number}
 */
export function hours(time = 0) {
  return time / 60;
}



// WEBPACK FOOTER //
// ./src/modules/common/utils/format.js